module.exports = __webpack_public_path__ + "img/OL.0425bb41.png";